import { inferUploadMime, isHeicMime } from "./upload-mime";

/**
 * Convert iPhone HEIC/HEIF locally before upload. This keeps preview, analysis,
 * InfiniteTalk and downstream providers on the broadly-supported JPEG path.
 */
export async function prepareMediaUploadFile(file: File): Promise<File> {
  const mime = inferUploadMime(file.name, file.type);
  if (isHeicMime(mime)) {
    try {
      const { heicTo } = await import("heic-to/csp");
      const converted = await heicTo({
        blob: file,
        type: "image/jpeg",
        quality: 0.9,
      });
      if (!(converted instanceof Blob)) throw new Error("Unexpected conversion output");
      return new File([converted], jpegFilename(file.name), {
        type: "image/jpeg",
        lastModified: file.lastModified,
      });
    } catch {
      throw new Error(
        "This iPhone photo could not be converted. Try exporting it as JPEG or choose Most Compatible in iPhone Camera settings.",
      );
    }
  }

  if (mime && mime !== file.type) {
    return new File([file], file.name, {
      type: mime,
      lastModified: file.lastModified,
    });
  }
  return file;
}

function jpegFilename(filename: string): string {
  return /\.(?:heic|heif)$/i.test(filename)
    ? filename.replace(/\.(?:heic|heif)$/i, ".jpg")
    : `${filename}.jpg`;
}
